import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "../../tools/AppConfig";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import Select from 'react-validation/build/select';
import Button from 'react-validation/build/button';
import Waiting from '../waiting';
import './../../custom.css';
import './../../pages/invoice.css';
import valu_logoImg from './../../../statics/img/payment_methods_logos/ValU.png';
import acceptBlueImg from './../../../statics/img/accept_blue.png';
import validator from 'validator';
import 'icheck/skins/all.css'; // or single skin css
import {Radio, RadioGroup} from 'react-icheck';
import './valu.css';
const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> This field is required.</div>;
  }
};
const PhoneNumber = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length > 14 || value.toString().trim().length < 8 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Phone number.</div>;
    }
};
const PremiumCard = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length !== 16 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Premium Card number.</div>;
    }
};
const Pin = (value) => {
    if(!validator.isNumeric(value) || value.toString().trim().length !== 6 ){
        return <div className="alert alert-danger fieldErrorMessage" role="alert"><i className="fa fa-exclamation-circle"></i> Please enter valid Premium Card number.</div>;
    }
};

class valu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            waiting: false,
            waitingHeight: '221px',
            userData: props.userData,
            deliveryNeed: props.deliveryNeed,
            deliveryData: props.deliveryData,
            phoneNumber: '',
            productAmount: props.userData.amount,
            downPayment: 0,
            financedAmount: props.userData.amount,
            quantity: this.props.quantity,
            plans: [],
            currentPlan: '',
            pmk: '',
            reference: '',
            pin: '',
            hideFirstStep: false,
            firstFormSubmitBtn: true,
            secondSetpShow: false,
        };
        this.getFirstName = this.getFirstName.bind(this);
        this.getLastName = this.getLastName.bind(this);
        this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);
        this.handleDownPaymentChange = this.handleDownPaymentChange.bind(this);
        this.handlePlanChange = this.handlePlanChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handelPinChange = this.handelPinChange.bind(this);
        this.handleForm2Submit = this.handleForm2Submit.bind(this);
        
    }
    componentDidMount(){
        this.setAmountValue();
    }
    componentDidUpdate(){
        // this.setAmountValue();
        if(this.state.quantity !== this.props.quantity){
            this.setState({quantity: this.props.quantity},() => {
                this.setAmountValue();
            })
        }
    }
    setAmountValue(){
        if(this.props.sourcePage ==='product'){
            let finalAmount = this.props.userData.amount * this.state.quantity;
            if(this.state.downPayment !== 0){
                finalAmount -= this.state.downPayment;
            }
            // this.state.productAmount= finalAmount;
            // this.state.financedAmount= finalAmount;
            this.setState({productAmount: finalAmount,financedAmount: finalAmount});
        }else if(this.props.sourcePage ==='invoice'){
            // this.state.productAmount= this.props.userData.order_amount_egp;
            // this.state.financedAmount= this.props.userData.order_amount_egp;
            this.setState({productAmount: this.props.userData.order_amount_egp, financedAmount: (this.props.userData.order_amount_egp - this.state.downPayment)});
        }
        //set plans
        let plansArr = [];
        this.state.userData.tenure_list.productList.forEach(product => {
            plansArr = [...plansArr, ...product.tenureList];
        })
        this.state.plans = plansArr
    }
    getFirstName(fullName) {
        var namesArr = fullName.split(" ");
        return namesArr[0]
    }
    getLastName(fullName) {
        var namesArr = fullName.split(" ");
        return namesArr[namesArr.length - 1];
    }
  handlePhoneNumberChange(e) {
    this.setState({phoneNumber: e.target.value});
  }
  handleDownPaymentChange(e){
    // let newFinancedAmount = this.state.productAmount - e.target.value; 
    this.setState({downPayment: e.target.value}, () => {
        this.setAmountValue()
    });
  }
  handlePlanChange(e){
    this.setState({currentPlan: e.target.value});
  }
  handleSubmit(event) {
    //--- strat waiting
    this.setState({waiting: true});
    //disable payment methods
    this.props.disableAllPaymentMethods();
    //---- send request 
    let url;
    if(this.props.sourcePage ==='invoice'){
        url = appConfig.getServerUrl() + '/invoice2/'+ this.state.userData.token;
    }else if(this.props.sourcePage ==='product'){
        url = appConfig.getServerUrl() + '/product2/'+ this.state.userData.token;
    }
    let paymentDict;
    if(this.props.sourcePage ==='invoice'){
        paymentDict = {
            "source": {
                "identifier": this.state.phoneNumber,
                "down_payment": this.state.downPayment,
                "tenure": this.state.currentPlan,
                "subtype": "VALU"
            }, 
            "shipping_data": {
                'apartment': "",
                'email': this.state.userData.order_email,
                'floor': "",
                'first_name': this.getFirstName(this.state.userData.order_full_name),
                'street': "",
                'building': "",
                'phone_number': this.state.userData.order_phone,
                'postal_code': "",
                'city': "",
                'country': "",
                'last_name': this.getLastName(this.state.userData.order_full_name),
                'state': "",
                'extra_description': ""
            },
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integration_ids.VALU        
        };
        if(this.state.deliveryNeed){
            paymentDict.shipping_data.country = this.state.deliveryData.country;
            paymentDict.shipping_data.state = this.state.deliveryData.state;
            paymentDict.shipping_data.city = this.state.deliveryData.city;
            paymentDict.shipping_data.building = this.state.deliveryData.building;
            paymentDict.shipping_data.street = this.state.deliveryData.street;
            paymentDict.shipping_data.floor = this.state.deliveryData.floor;
            paymentDict.shipping_data.apartment = this.state.deliveryData.apartment;
            paymentDict.shipping_data.postal_code = this.state.deliveryData.postal_code;
            paymentDict.shipping_data.extra_description = this.state.deliveryData.notes;
        }
    }else if(this.props.sourcePage ==='product'){
        paymentDict = {
            "order_data": {
                "delivery_needed": this.state.deliveryNeed,
                "amount_cents": this.state.userData.amount * this.props.quantity * 100,
                "currency": this.state.userData.currency,
                "shipping_data": {
                    "first_name": this.getFirstName(this.state.deliveryData.name),
                    "last_name": this.getLastName(this.state.deliveryData.name),
                    "phone_number": this.state.deliveryData.phone,
                    "email": this.state.deliveryData.email,
                    "street": 'NA',
                    "city": 'NA',
                    "country": 'NA',
                    "postal_code": 'NA',
                    "state": "NA"
                },
                "items": [{
                    "name": this.state.userData.product.product_name,
                    "amount_cents": this.state.userData.amount * 100,
                    "quantity": this.props.quantity,
                }]
            },
            "source": {
                "identifier": this.state.phoneNumber,
                "down_payment": this.state.downPayment,
                "tenure": this.state.currentPlan,
                "subtype": "VALU"
            },
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integrations.VALU
        };
        if(this.state.deliveryNeed){
            paymentDict.order_data.shipping_data.country = this.state.deliveryData.country;
            paymentDict.order_data.shipping_data.state = this.state.deliveryData.state;
            paymentDict.order_data.shipping_data.city = this.state.deliveryData.city;
            paymentDict.order_data.shipping_data.building = this.state.deliveryData.building;
            paymentDict.order_data.shipping_data.street = this.state.deliveryData.street;
            paymentDict.order_data.shipping_data.floor = this.state.deliveryData.floor;
            paymentDict.order_data.shipping_data.apartment = this.state.deliveryData.apartment;
            paymentDict.order_data.shipping_data.postal_code = this.state.deliveryData.postal_code;
            paymentDict.order_data.shipping_data.extra_description = this.state.deliveryData.notes;
        }
    }
    paymentDict = JSON.stringify(paymentDict);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.post(url, paymentDict, config)
    .then((resp) => {        
        if(resp.data.success){
            //set pmk value & reference value and & waiting & show second form % disable first form & remove first form submit button
            this.setState({pmk: resp.data.pmk, reference: resp.data.reference, waiting: false, secondSetpShow: true, hideFirstStep: true, firstFormSubmitBtn: false});
            //enable payment methods
            this.props.enableAllPaymentMethods();
        } else {
            if (resp.data.url) {
                window.location.replace(resp.data.url);
                //window.location.href = resp.data.redirection_url;
            }
            if (resp.data.data.message) {
                this.props.setReqComplete({head: 'Transaction declined', body: resp.data.data.message });
            } else {
                this.props.setReqComplete({head: 'Transaction declined', body: 'Please try again later. If this problem persists, please contact your service provider.'});
            }
        }
    })
    .catch((err) => {
        this.props.setReqComplete({head: 'Transaction declined', body:'Please try again later. If this problem persists, please contact your service provider.'});
    });
    event.preventDefault();
  }
  handelPinChange(e){
    this.setState({pin: e.target.value});
  }
  handleForm2Submit(event){
    //--- strat waiting
    this.setState({waitingHeight: '289px', waiting: true});
    //disable payment methods
    this.props.disableAllPaymentMethods();
    //send request
    let url= appConfig.getServerUrl() + '/api/acceptance/valu_checkout';
    let opt_dict = {
        "payment_token": this.state.pmk,
        "reference": this.state.reference,
        "otp": this.state.pin
    };
    let paymentDict = JSON.stringify(opt_dict);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.post(url, paymentDict, config)
    .then((resp) => {
        if(resp.data.success == true || resp.data.success === "true"){
            // if(resp.data.redirection_url){
            //     window.location.replace(resp.data.redirection_url);
            //     //window.location.href = resp.data.redirection_url;
            // }else 
            if(resp.data.data.message){
                this.props.setReqComplete({head: 'Payment Successful', body: resp.data.data.message});
            }else{
                this.props.setReqComplete({head: 'Payment Successful', body:'Congratulations, your transaction completed successfully.'});
            }
        }else{
            //succes = false
            if(resp.data.data.message){
                this.props.setReqComplete({head: 'Transaction declined', body: resp.data.data.message});
            }else{
                this.props.setReqComplete({head: 'Transaction declined', body:'Please make sure that you entered the correct OTP.'});
            }
        }
    })
    .catch((err) => {
        this.props.setReqComplete({head: 'Something went wrong', body:'Please try again later. If this problem persists, please contact your service provider.'});
    });
    event.preventDefault();
  }
    calcPurchase = () => {
        if(this.state.currentPlan){	
            if (this.props.userData.purchase_fees_dict){
                return (this.state.financedAmount * (this.props.userData.purchase_fees_dict[this.state.currentPlan])).toFixed(2)
            }
            else if(this.props.userData.intrest_rate[this.state.currentPlan] == 0){
                return (this.state.financedAmount * 0.05).toFixed(2)
            }else{
                return (this.state.financedAmount * 0.03).toFixed(2)
            }
        }else{
            return " - "
        }
    }
  render() {
    return (
            <div className="valuNew">
                {this.state.waiting ? 
                    <Waiting height={this.state.waitingHeight} />
                :  
                    <div>
                        {this.state.hideFirstStep?
                            null
                        :
                            <Form onSubmit={this.handleSubmit}>
                                <div>
                                    <div className="row">
                                        <div className="col-md-6 col-sm-12 ">
                                            <div className="newInput">
                                                 <label>Enter your phone number</label>
                                                    <Input type="number" pattern="[0-9]*"  name="c_pan_U" placeholder="01 xxx xxx xxx"
                                                        value={this.state.phoneNumber} 
                                                        onChange={this.handlePhoneNumberChange}
                                                        validations={[required, PhoneNumber]}
                                                    />
                                            </div>
                                        </div>
                                        {this.state.userData && this.state.userData.allow_downpayment == false ?
                                            null
                                        :
                                            <div className="col-md-6 col-sm-12 ">
                                                <div className="newInput">
                                                    <label>Down Payment <small>(maximum down payment amount is 80% of the product price)</small></label>
                                                        <Input type="number"  placeholder="0"
                                                            value={this.state.downPayment} 
                                                            onChange={this.handleDownPaymentChange}
                                                            validations={[required]}
                                                        />
                                                </div>
                                            </div>
                                        }
                                        
                                    </div>

                                    <div className="InstallmentAmountContainer">
                                        <div className="InstallmentAmount">
                                                <p>Installment:  {this.state.financedAmount}</p>
                                        </div>
                                        {this.props.userData.has_purchase_fees_in_standalone && 
                                            <div className="InstallmentAmount">
                                                <p>Purchase Fees:  {this.calcPurchase()}</p>
                                            </div>
                                        }
                                    </div>

                                    <div className="plansDiv">
                                        <Input type="hidden" className="form-control" placeholder="100"
                                            value={this.state.currentPlan}
                                            validations={[required]}
                                        />
                                        <RadioGroup name="radio"  onChange = {this.handlePlanChange} required>
                                            {this.state.plans.map((plan, index) => {
                                                return <Radio
                                                    key= {plan.tenorMonth} 
                                                    value={plan.tenorMonth}
                                                    radioClass={this.state.currentPlan == plan.tenorMonth ? "iradio_square-blue checked" : "iradio_square-blue"}
                                                    increaseArea="20%"                                
                                                    label={"<span class='paymentMethodSpan'><b>" + plan.tenorMonth + " Months</b><span>" + plan.emi + "/month</span></span>"}
                                                />
                                            })}
                                        </RadioGroup>
                                    </div>
                                    
                                   
                                    {this.state.firstFormSubmitBtn?
                                        <div className='text-center'>
                                            <Button className="confirmBtnNew">Submit</Button>
                                        </div>
                                    :
                                        null
                                    }
                                </div>
                            </Form>
                        }
                        <Form onSubmit={this.handleForm2Submit}>
                            {this.state.secondSetpShow?
                                <div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <div className="newInput">
                                                <label>Please enter One Time Pin (OTP)</label>
                                                <Input type="text" name="one time pin" placeholder="PIN"
                                                    value={this.state.pin}
                                                    onChange={this.handelPinChange}
                                                    validations={[required]} 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='text-center'>
                                        <Button className="confirmBtnNew">Pay</Button>
                                    </div>
                                </div>
                            :
                                null
                            }
                        </Form>
                    </div>
                }
            </div>
    );
  }
}

export default valu;
